import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status:0,
    userData:false,
  },
  mutations: {
    setStatus(state,status){
      state.status = status
    },
    setUserData(state,data){
      state.userData = data
    },
    setUserQuotationData(state,data){
      state.userData['quotation'] = data
    }
  },
  actions: {
  },
  modules: {
  }
})
